import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { monsterTypeIcons } from '../../images'
import { StyledCardTypeImage } from './CardTypeIcon'

const placeholders = {
	24: {
		color: 'gold',
		label: 'CG'
	},
	4: {
		color: 'teal',
		label: 'CY'
	},
	23: {
		color: '#bd6b40',
		label: 'WY'
	},
	26: {
		color: 'purple2',
		label: 'IL'
	}
}

const MonsterTypeIcon = ({ id }) => (
	<StyledCardTypeImage>
		{monsterTypeIcons[id] && <img src={monsterTypeIcons[id]} alt="" />}
		{!monsterTypeIcons[id] && <MonsterTypeIconPlaceholder color={placeholders[id].color}>{placeholders[id].label}</MonsterTypeIconPlaceholder>}
	</StyledCardTypeImage>
)

MonsterTypeIcon.propTypes = {
	id: PropTypes.number.isRequired
}

const MonsterTypeIconPlaceholder = styled.div`
	background-color: ${props => props.theme[props.color] || props.color};
	width: 22px;
	height: 22px;
	clip-path: polygon(18.75% 0, 81.25% 0, 100% 18.75%, 100% 81.25%, 81.25% 100%, 18.75% 100%, 0 81.25%, 0 18.75%);

	display: flex;
	align-items: center;
	justify-content: center;
	font-size: 0.8rem;
	font-weight: bold;
	color: ${props => props.theme.white};
	font-family: ${props => props.theme.fontMonospace};
`

export default MonsterTypeIcon
